// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-list__total-icon.v-icon{font-size:24px!important}.progress-list__item__text{color:#333}.progress-list__item__icon{margin-left:.25rem;width:1.5rem}.progress-list__item--error .progress-list__item__text{color:#c73629}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
